import { FC } from 'react';

import { useTranslation } from 'next-i18next/pages';

import { Button } from 'antd';

import { MAKE_REGISTRATION_URL } from '@/constants/routes';
import { useSafeAsPath } from '@/hooks/migration/use-safe-as-path';
import { useSafeRouter } from '@/hooks/migration/use-safe-router';
import { TranslationNamespace } from '@/i18n';

import styles from './FishplaceNumbers.module.scss';

export const JoinButton: FC = () => {
	const router = useSafeRouter();
	const asPath = useSafeAsPath();
	const { t } = useTranslation(TranslationNamespace.Marketing);

	const handleJoin = () => {
		return router.push(MAKE_REGISTRATION_URL({ redirectTo: asPath }));
	};

	return (
		<Button
			className={styles.button}
			size="large"
			type="default"
			onClick={handleJoin}
			data-testid="about-registration-btn"
		>
			{t('about-us-container.join')}
		</Button>
	);
};
